module.exports = __webpack_public_path__ + "img/ar.f1508642.svg";